import { ColProps } from 'antd';
import clsx from 'clsx';
import { AntCol } from 'components/ant/AntCol';
import React from 'react';

import s from './Shared.module.less';

export const ColCenterContent: React.FC<ColProps> = ({ className, ...rest }) => (
  <AntCol {...rest} className={clsx(s.colCenterContent, className)} />
);

export const ColLeftSidebar: React.FC<ColProps> = ({ className, ...rest }) => (
  <AntCol {...rest} className={clsx(s.colLeftSidebar, className)} />
);

export const ColRightSidebar: React.FC<ColProps> = ({ className, ...rest }) => (
  <AntCol {...rest} className={clsx(s.colRightSidebar, className)} />
);
